import React from "react";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import { useUserProfile } from "@app.automotus.io/components/hooks";

export const TransactionSummaryTitle: React.FC = () => {
  const { userProfile, loading } = useUserProfile();

  return (
    <Typography variant="h4" component="h1" fontWeight={600} sx={{ fontSize: { xs: "1.5rem", md: "2.125rem" } }}>
      {loading || !userProfile ? (
        <Skeleton width="80%" />
      ) : (
        `Transactions for ${userProfile.account.organizationName || userProfile.account.holderName}`
      )}
    </Typography>
  );
};

export default TransactionSummaryTitle;
